<template>
  <div class="room">
    <div class="page-search-block">
      <div class="search-bar inline-block">
        <!-- <span class="w-90 inline-block align-r m-r-8">高级筛选：</span> -->
        <div class="m-b-18 inline-block">
          <span class="w-50 inline-block align-r m-r-8">房型：</span>
          <el-select v-model="filters.search.roomTypeId" class="m-r-8 w-120"  clearable   >
            <el-option key="roomttypall" value="" label="全部"></el-option>
            <el-option v-for="(item) in selOptions.roomType" :key="'roomTypeNa_'+item.id" :label="item.roomTypeName" :value="item.id"></el-option>
          </el-select>
        </div>
        <div class="m-b-18 inline-block">
          <el-select v-model="filters.search.room" class="select-as-label w-100 m-r-8">
            <el-option key="rom1" value="roomName" label="房源名称"></el-option>
            <el-option key="rom2" value="roomCode" label="房源编码"></el-option>
          </el-select>
          <el-input v-model="filters.search.roomValue" class="w-120" placeholder="请输入" ></el-input>
        </div>
        <div class="m-b-18 inline-block">
          <span class="w-90 inline-block align-r m-r-8">审核状态：</span>
          <el-select v-model="filters.search.reviewStatus" class="m-r-8 w-120" clearable >
            <el-option key="rtypall" value="" label="全部"></el-option>
            <el-option key="rtyp1" value="1" label="审核中"></el-option>
            <el-option key="rtyp2" value="2" label="已通过"></el-option>
            <el-option key="rtyp2" value="3" label="未通过"></el-option>
            <el-option key="rtyp2" value="4" label="已注销"></el-option>
          </el-select>
        </div>
        <div class="m-b-18 inline-block">
          <span class="w-90 inline-block align-r m-r-8">经营者：</span>
          <el-input v-model="filters.search.managerName" class="w-120" placeholder="请输入" ></el-input>
        </div>
        <div class="m-b-18 inline-block">
          <span class="w-90 inline-block align-r m-r-8">经营状态：</span>
          <el-select v-model="filters.search.businessStatus" class="m-r-8 w-120"  clearable  >
            <el-option key="btypall" value="" label="全部"></el-option>
            <el-option key="btyp1" value="1" label="待上架"></el-option>
            <el-option key="btyp2" value="2" label="已上架"></el-option>
            <el-option key="btyp2" value="3" label="已下架"></el-option>
          </el-select>
        </div>
        <div class="m-b-18 inline-block">
          <span class="w-90 inline-block align-r m-r-8">区域：</span>
          <area-cascader v-model="filters.search.areaCode" :endLevel="4" class="m-r-8 w-120" checkStrictly></area-cascader>
        </div>
        <el-button class="submit-btn" size="medium" type="warning" @click="formSearch()">搜 索</el-button>
        <el-button class="submit-btn" size="medium" @click="reset">重 置</el-button>
      </div>
    </div>
    
    <div class="page-operate-block">
      <div class="tit"></div>
      <div>
        <el-button v-permission="'add'" class="primary-btn-g m-r-xs" name="dataSetting" @click="handleEdit('add')" type="warning">新增</el-button>
        <el-button v-permission="'add'" class="primary-btn-g m-r-xs" name="dataSetting" @click="handleEdit('copy')" :disabled="options.selection.length!=1" plain type="primary">复制</el-button>
        <el-button v-permission="'update'" class="primary-btn-g m-r-xs" name="dataSetting" :disabled="options.selection.length!=1" @click="handleEdit('edit')" plain type="success">变更</el-button>
        <el-button v-permission="'delete'" :disabled="options.selection.length === 0" @click="handleDelete" plain type="danger">删除</el-button>
        <el-popover placement="bottom" trigger="click" popper-class="r-popover">
          <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
          <br />
          <el-checkbox v-for="(column, index) in tableColumn" v-model="column.visible" :key="index" @change="_checkChange">{{column.label}}</el-checkbox>
          <template #reference>
            <el-button  class="primary-btn-g" name="dataSetting" plain type="warning">数据项</el-button>
          </template>
        </el-popover>
      </div>
    </div>
    <div class="table-list-block">

      <r-table
        class="manager-table"
        :ref="tableVarity"
        :columns="tableColumn"
        :dataSource="tableData"
        :options="options"
        :pagination="pagination"
        @current-change="handlePageChange"
        @row-click="handleRowClick"
      >
      </r-table>
    </div>
    <!--查看-->
    <RModal :title="modalTitles[detailType]" v-model="detailModal" top="3vh" :closeOnClick="false" @change="detailModal = false" @close="closeModel">
      <template #content>
        <detail-view v-if="detailType=='show'" :detailModal="detailModal" :detailData="detailData" :selOptions="selOptions"></detail-view>
        <edit-view v-else-if="detailType=='add' || detailType=='edit' || detailType=='copy'" :detailType="detailType" :detailModal="detailModal" :detailData="detailData" :selOptions="selOptions" @submitSuccess="submitSuccess" @closeModel="closeModel">
        </edit-view>
        <lock-bind v-else-if="detailType=='bind'" :detailType="detailType" :detailModal="detailModal" :detailData="detailData" :selOptions="selOptions" @submitSuccess="submitSuccess" @closeModel="closeModel">
        </lock-bind>
        <check-view v-else-if="detailType=='check'" :detailType="detailType" :detailModal="detailModal" :detailData="detailData" :selOptions="selOptions" @submitSuccess="submitSuccess" @closeModel="closeModel">
        </check-view>
      </template>
    </RModal>

    <RModal :title="distributeType == 'distribute' ? '分配房源' : '回收房源'" width="600px" :show="distributeModal" :closeOnClick="false" @change="distributeModal = false" @close="distributeModal = false">
      <template #content>
        <DistributeView :operatorButlerList="operatorButlerList" :roomSel="options.selection" :distributeModal="distributeModal" :distributeType="distributeType" @close="distributeModal = false" @submitSuccess="submitSuccess" @closeModel="closeModel" />
      </template>
    </RModal>
  </div>
</template>

<script>
  import { mapActions, mapGetters ,mapState} from 'vuex'
  import RModal from '@/components/common/RModal'
  import RTable from '@/components/common/RTable'
  import tableMix from '@/components/common/tableListMixin.js'
  import checkMix from '@/components/common/checkAll.js'
  import detailView from './detailView'
  import editView from './editView'
  import lockBind from './lockBind'
  import checkView from './checkView'
  import DistributeView from './distributeView.vue'
  import moment from 'moment'
import AreaCascader from '@/components/common/areaCascader.vue'
export default {
  name: 'employeeIndex',
  mixins: [tableMix, checkMix],
  components: {
    RTable,
    detailView,
    RModal,
    editView,
    lockBind,
    checkView,
    DistributeView,
    AreaCascader
  },
  data() {
    let detailKeys = ['reviewStatus','businessStatus','roomName','roomTypeId','storeId','areaCode','managerName']
    let searchData = {'room': 'roomName'}
    detailKeys.map((key)=>{
      searchData[key] = ''
    })

    return {
      modalTitles:{add:'新增',edit:'变更',check:'审核',show:'详情',copy:'复制',bind:'绑定'},
      perms: [],
      distributeType: 'distribute',
      distributeModal: false,
      hasNoManager: false, // 还没创建经营者
      noCheckFunc: false, // 没有审核流程

      noCheckTabsArr: [{ label: '经营中', name: '1' ,originLabel: '经营中' }, { label: '已注销', name: '2' ,originLabel: '已注销' }],
      tabsArr:[{
        label: '已通过',
        name: '1',
        originLabel: '已通过'
      },{
        label: '审核中',
        name: '0',
        originLabel: '审核中'
      },{
        label: '未通过',
        name: '-1',
        originLabel: '未通过'
      },{
        label: '已注销',
        name: '2',
        originLabel: '已注销'
      }],
      modalTitle:'详情',
      activeSubName:'1',
      detailModal:false,
      detailType:'show',
      uploadModal:false,
      downloadUrl:'',
      detailData:{},
      deleteUrl:'SAAS.ROOM_DELETE',
      areUOk: false,
      tableVarity: 'baseinfo_room',
      tableColumn: [],
      tableData: [],
      selOptions:{roomType:[], rentType:[],wyfptdwbm:[],ownerCountry:[],ownerCreditCode:[],jyzbm:[],classifyValue:[]},
      selOptionMaps:{roomType:{}, rentType:{},wyfptdwbm:{},ownerCountry:{},ownerCreditCode:{},jyzbm:{}},
      options: {
        multiSelect: true, // 多选
        serialNum: false, // 显示序号
        loading: false, // 加载中状态
        initTable: true, // 是否一挂载就加载数据
        mutiSelect: true,
        selection: [],
      },
      pagination: {
        total: 0,
        pageIndex: 1,
        pageSize: 20,
      },
      // 查询参数
      filters: { search: searchData },
      filtersInitSearchData:{...searchData},
      boxSearchKey:'',
      //树结构的数据
      treeData: [
        {
          id: '0',
          type: 'all',
          label: '全部',
          text: '全部',
          children: [{
            id: '1',
            type: 'classType',
            label: '民宿',
            text: '民宿',
            pValue:2,
            children: [],
          },
            {
              id: '2',
              type: 'classType',
              label: '酒店',
              text: '酒店',
              pValue:1,
              children: [],
            }],
        },
      ],
      // 树组件配置
      defaultProps: {
        children: 'children',
        label: 'label',
      },
      searchType:'formSearch',
      operatorButlerList:[],
      wyfdzSsxqdm_provinceDicts:[],
      wyfdzSsxqdm_cityDicts:[],
      wyfdzSsxqdm_areaDicts:[],
      wyfdzSsxqdm_policeDicts:[],
      wyfdzSsxqdm_streetOfficeDicts:[],
      wyfdzSsxqdm_neighborCmmDicts:[],
      formData:{dwbgdzSfbm:'',dwbgdzSbm:'',dwbgdzQbm:'',streetOffice:'',neighborCmm:'',dwbgdzSsxq:''},
      roomFilterDatas:{isExamine:'1',type:''},
      roomTypeInfos:[{label:'全部',value:'',count:0},{label:'民宿',value:'2',count:0},{label:'酒店',value:'1',count:0}],
      roomStatusInfos:[{label:'已通过',value:'1',count:0},{label:'审核中',value:'0',count:0},{label:'未通过',value:'-1',count:0},{label:'已注销',value:'2',count:0}]
    }
  },
  computed: {
    ...mapState({
      LoginonUser: (state) => state.common.user,
    }),
    // 新疆用户按钮是否可见
    checkBtnDisabled() {
      let hasPerm = false
      let permList = localStorage.getItem('perms')
      permList = permList ? JSON.parse(permList) : []
      for (let i = 0; i < permList.length; i++) {
        if (permList[i].id == 6023) {
          hasPerm = true
          break
        }
      }

      return hasPerm
    },

    enableAreaSelBtn(){
      //userType:超级管理员2， 区域管理员1， 经营者0， 管家3，
      if (this.userInfo.userType == 1 || this.userInfo.userType == 2){
        return false
      }else{
        return true
      }
    }
  },

  watch: {
    boxSearchKey(val){
      this.$refs.roomTree.filter(val)
    }
  },
  
  created() {
    this.$eventBus.on('change-shop', store => {
      this.$nextTick(()=>{
        this.handleSearch()
        this.getDictData()
      })
    })

    this.perms = 'perms' in localStorage && localStorage.perms !== '' ? JSON.parse(localStorage.perms) : []
    this.userInfo = localStorage.getItem('user')
    this.userInfo = this.userInfo ? JSON.parse(this.userInfo) : {}

    this.roomFilterDatas = {
      dwbgdzSfbm:this.userInfo.provinceId,
      dwbgdzSbm:this.userInfo.cityId,
      dwbgdzQbm:this.userInfo.regionId,
      streetOffice:this.userInfo.streetOffice,
      neighborCmm:this.userInfo.neighborCmm,
      isExamine:'1',
      type:''
    }

    this.initTableColumns()
    //this.getRoomTypes()
    this.getDictData()
    this.getDataList()


    if (this.userInfo.userType == 1 || this.userInfo.userType == 2) {
      //this.getHasCheckFunc(this.userInfo.provinceId, this.userInfo.cityId, this.userInfo.regionId)
    }
  },
  beforeUnmount() {
    this.$eventBus.off('change-shop')
  },
  beforeRouteLeave(){
    this.$eventBus.off('change-shop')
  },
  mounted() {
    this.getDataList()
  },
  methods: {
    ...mapActions(['importUpload']),
    // 是否拥有这个权限
    hasThisPerm(perm) {
      let url = window.location.pathname.substr(5)
      let len = this.perms.length

      for (let i = 0; i < len; i++) {
        if (this.perms[i].perm == perm) {
          return true
        }
      }

      return false
    },

    //tab点击
    handleTabClick(tab){
      this.activeSubName = tab
      /*
        已注销状态下才有“注销时间”字段，其他状态下没有
        未通过状态下才有“未通过原因”，其他状态下没有
        “审核时间”只在“已通过、未通过、已注销状态下有
       */
      this.searchType = 'treeSearch'
      this.handleSearch()
    },
    //1:已通过;0:审核中;-1:未通过;2:已注销
    handleTypeClick(name,value){
      localStorage.setItem('curRoomPage' + name, value) // 记录当前房源页面选中的tab项，用途：刷新后恢复选中的tab

      this.roomFilterDatas[name] = value
      if(name=='isExamine'){
        this.activeSubName = value
      }

      this.searchType = 'treeSearch'
      //this.getDataList()
      this.handleSearch()
    },
    //房源类目数据获取
    getRoomTypes(){
      /*classifyValue*/
      this.fetchData({
        url:'SAAS.ROOM_LIST',
        method: 'get',
        params: {
          start: 0,
          size: 200,
          toExcel: false,
          params:JSON.stringify({requestType:1})
        }
      }).then( res => {
        let tmpArr = []
        if (res && res.enum) {
          for(let className in res.enum[1]) {
            if(tmpArr.indexOf(className)<0 && className!='未分类'){
              res.enum[1][className] && tmpArr.push({label:className,value:className})
            }
          }
          for(let className in res.enum[2]) {
            if(tmpArr.indexOf(className)<0 && className!='未分类'){
              res.enum[2][className] && tmpArr.push({label:className,value:className})
            }
          }
        }

        this.selOptions.classifyValue = tmpArr
        let maps = {}
        res.data.map((obj)=>{
          maps[obj.name] = obj.value
        })
        this.selOptionMaps.classifyValue = {}
      })
    },
    // 获取字典数据
    getDictData() {
      let url = 'RESOURCE.QUERY_DICTS_LIST'
      this.fetchData({
        url,
        method: 'get',
        params: {
          types: 'certType,rentType,countryCode'
        },
        flag:true
      }).then( res => {
        if(!res || res.code!=200){
          return false
        }
        let keys = {ownerCountry:'countryCode',rentType:'rentType',ownerCertType:'certType'}
        let keyData = []
        for(let keyName in keys){
          keyData = res.data[keys[keyName]]
          this.selOptions[keyName] = keyData
          let maps = {}
          keyData.map((obj)=>{
            maps[obj.name] = obj.value
          })
          this.selOptionMaps[keyName]  = maps
        }
      }).catch((err) => {
        console.log(err, 'errorInfo')
      })
      
      //房型
      let params = {pageNumber: 1,pageSize: 99999999}
      let curStoreInfo = this.getCurStoreInfo()
      if(curStoreInfo && curStoreInfo.id){
        params['storeId'] = curStoreInfo.id
        url = 'SAAS.ROOM_TYPE_LIST'
        this.fetchData({
          url,
          method: 'get',
          params,
        }).then((res) => {
          this.selOptions.roomType = res.data || []
          let roomTypeMap = {}
          res.data && res.data.length && res.data.forEach((item)=>{
            roomTypeMap[item.id] = item.roomTypeName
          })
          this.selOptionMaps.roomType = roomTypeMap
        })
        .catch((err) => {
          console.log(err, 'errorInfo')
        })
        //this.initAreaData()
      }else {
        // 若门店不存在，则直接将对应房型列表置空，若不传storeId，直接调用接口，会获取到所有房型列表
        this.selOptionMaps.roomType = []
      }
    },

    //区域数据初始化
    initAreaData(){
      //省市区域
      // getCity
      let p1 = this.fetchData({
        url:'RESOURCE.FIND_AREA_LIST_BY_PARENT_CODE',
        method: 'get',
        params:{ parentCode: this.roomFilterDatas.dwbgdzSfbm }
      })
      //getArea
      let p2 = this.fetchData({
        url:'RESOURCE.FIND_AREA_LIST_BY_PARENT_CODE',
        method: 'get',
        params:{ parentCode: this.roomFilterDatas.dwbgdzSbm }
      })
      //getStreet
      let p3 = this.fetchData({
        url:'RESOURCE.FIND_AREA_LIST_BY_PARENT_CODE',
        method: 'get',
        params:{ parentCode: this.roomFilterDatas.dwbgdzQbm }
      })
      //getComm
      let p4 = this.fetchData({
        url:'RESOURCE.FIND_AREA_LIST_BY_PARENT_CODE',
        method: 'get',
        params:{ parentCode: this.roomFilterDatas.streetOffice }
      })
      //getPoliceStation
      let p5 = this.fetchData({
        url:'RESOURCE.FIND_AREA_LIST_BY_PARENT_CODE',
        method: 'get',
        params:{ parentCode: 0 }
      })


      Promise.all([p1, p2, p3, p4, p5]).then(([res1, res2, res3, res4, res5]) => {
        let tempArr = []
        res5 && res5.data.forEach(re => {
          if (re.areaName) {
            tempArr.push({
              value: re.areaCode,
              label: re.areaName,
              areaCode: re.areaCode,
              areaName: re.areaName
            })
          }
        })
        this['wyfdzSsxqdm_provinceDicts'] = [...tempArr]

        this.handleAreaChange(res1,"getCity",true)
        this.handleAreaChange(res2,"getArea",true)
        this.handleAreaChange(res3,"getStreetOffice",true)
        this.handleAreaChange(res4,"getNeighborCmm",true)

      }).catch((err)=>{
      }).finally(()=>{
      })
    },

    //区域变更
    handleAreaChange(res,evt,flag){
      let tempArr = []
      res.data.forEach(re => {
        if (re.areaName) {
          tempArr.push({
            value: re.areaCode,
            label: re.areaName,
            areaCode: re.areaCode,
            areaName: re.areaName,
          })
        }
        if (re.name) {
          tempArr.push({
            value: re.policeCode,
            label: re.name,
          })
        }
      });
      if (evt === 'getCity') {
        this.wyfdzSsxqdm_cityDicts = tempArr;
        if (flag) {
          return
        }
        this.formData.dwbgdzSbm = '';
        this.formData.dwbgdzQbm = '';
        this.formData.streetOffice = ''
        this.formData.neighborCmm = ''
        this.formData.dwbgdzSsxq = '';
      }
      if (evt === 'getArea') {
        this.wyfdzSsxqdm_areaDicts = tempArr;
        if (flag) {
          return
        }
        this.formData.dwbgdzQbm = '';
        this.formData.streetOffice = ''
        this.formData.neighborCmm = ''
        this.formData.dwbgdzSsxq = '';
      }
      if (evt === 'getStreetOffice') {
        this.wyfdzSsxqdm_streetOfficeDicts = tempArr;
        if (flag) {
          return
        }
        this.formData.streetOffice = ''
        this.formData.neighborCmm = ''
        this.formData.dwbgdzSsxq = '';
      }
      if (evt === 'getNeighborCmm') {
        this.wyfdzSsxqdm_neighborCmmDicts = tempArr;
        if (flag) {
          return
        }
        this.formData.neighborCmm = ''
        this.formData.dwbgdzSsxq = '';
      }
      if (evt === 'getPoliceStation') {
        this.wyfdzSsxqdm_policeDicts = tempArr;
        if (flag) {
          return
        }
        this.formData.dwbgdzSsxq = '';
      }
    },

    selectedChange(code, evt ,flag = false) {
      this.formSearch()
      let url = 'RESOURCE.FIND_AREA_LIST_BY_PARENT_CODE'
      let realCode = code
      /*let code = codeValue.substr(-6)*/
      let params = { areaCode: realCode }
      this.fetchData({
        url,
        method: 'get',
        params
      }).then(res => {
        let tempArr = []
        res.data.forEach(re => {
          if (re.areaName) {
            tempArr.push({
              value: re.areaCode,
              label: re.areaName,
              areaCode: re.areaCode,
              areaName: re.areaName,
            })
          }
          if (re.name) {
            tempArr.push({
              value: re.policeCode,
              label: re.name,
            })
          }

        });
        if (evt === 'getCity') {
          this.wyfdzSsxqdm_cityDicts = tempArr;
          if (flag) {
            return
          }
          this.resetData(this.roomFilterDatas,['dwbgdzSbm','dwbgdzQbm','streetOffice','neighborCmm'],'')
          this.wyfdzSsxqdm_areaDicts = []
          this.wyfdzSsxqdm_streetOfficeDicts = []
          this.wyfdzSsxqdm_neighborCmmDicts = [];
        }
        if (evt === 'getArea') {
          this.wyfdzSsxqdm_areaDicts = tempArr;
          if (flag) {
            return
          }
          this.resetData(this.roomFilterDatas,['dwbgdzQbm','streetOffice','neighborCmm'],'')
          this.wyfdzSsxqdm_streetOfficeDicts = []
          this.wyfdzSsxqdm_neighborCmmDicts = [];
        }
        if (evt === 'getStreetOffice') {
          this.wyfdzSsxqdm_streetOfficeDicts = tempArr;
          if (flag) {
            return
          }
          this.resetData(this.roomFilterDatas,['streetOffice','neighborCmm'],'')
          this.wyfdzSsxqdm_neighborCmmDicts = [];
        }
        if (evt === 'getNeighborCmm') {
          this.wyfdzSsxqdm_neighborCmmDicts = tempArr;
          if (flag) {
            return
          }
          this.resetData(this.roomFilterDatas,['neighborCmm'],'')
        }
      }).catch(err => {
        this.error = err
      })
    },

    //清空数据
    resetData(objName1,names,value){
      names.map((item)=>{
        objName1[item] = value
      })
    },

    reset(){
      // 重置
      this.$router.replace({
        path: "roomInfo",
        query: {},
      })
      this.resetFilter();
      setTimeout(() => {
        this.formSearch();
      });
    },

    // 查询列表数据
    getQuery() {
      //this.filters.search.isExamine = this.activeSubName
      let params = this.getQueryListParams()
      if(this.$route.query.managerCode){
        params.managerCode = this.$route.query.managerCode;
      }
      if(this.$route.query.roomTypeId){
        params.roomTypeId = this.$route.query.roomTypeId;
        this.filters.search.roomTypeId = this.$route.query.roomTypeId;
        this.$router.replace({
          path: "/roomInfo",
          query: {},
        })
      };
      if(params.room && params.roomValue){
        params[params.room] = params.roomValue
      }
      if(params.areaCode && params.areaCode.length){
        params.areaCode = params.areaCode[params.areaCode.length - 1];
      }
      console.log(params);
      let curStoreInfo = this.getCurStoreInfo()
      if(curStoreInfo && curStoreInfo.id){
        params['storeId'] = curStoreInfo.id
      }

      delete params.room

      let url = 'SAAS.ROOM_LIST'
      this.fetchData({
        url,
        method: 'get',
        params,
      }).then((res) => {
          this.options.loading = false
          if (this.toExcel == true) {
            if (!res || !res.data) {
              this.$message.error('操作失败！')
            } else {
              window.location.href = res.data
            }
            this.toExcel = false
            return
          }

          this.searchType = 'formSearch'
          if (!res || !res.data) {
            this.tableData = []
            this.pagination.total = 0
          } else {
            this.tableData = res.data || []
            this.pagination.total = res.count
          }
        })
        .catch((err) => {
          console.log(err, 'errorInfo')
        })
        .finally(() => {
          this.options.loading = false
          this.toExcel = false
        })
    },
    // 初始化自定义表头
    initTableColumns() {
      let columns = [
        { prop: 'roomName', label: '房源名称', visible: true, minWidth: 160 },
        { prop: 'roomTypeName', label: '房型', visible: true, minWidth: 160, align:'center' },
        { prop: 'roomNumber', label: '房间号', visible: true, minWidth: 80, align:'center'},
       /* { prop: 'sort', label: '排序', visible: true, minWidth: 80, isInput: true  },*/
        { prop: 'areaName', label: '省市区（县）', visible: true, minWidth: 200},
        { prop: 'streetOffice', label: '街道', visible: true, minWidth: 160},
        { prop: 'neighborCmm', label: '社区', visible: true, minWidth: 160},
        { prop: 'addrDetail', label: '详细地址', visible: true, minWidth: 200},
        { prop: 'roomSize', label: '经营面积', visible: true, minWidth: 80, align:'center'},
        { prop: 'bedroomNum', label: '房屋间数', visible: true, minWidth: 80, align:'center'},
        { prop: 'bedNum', label: '床位数', visible: true, minWidth: 80, align:'center'},
        { prop: 'maxLiveNum', label: '宜住人数', visible: true, minWidth: 80, align:'center'},
        { prop: 'businessStatus', label: '经营状态', visible: false, minWidth: 80, align:'center' },
        { prop: 'reviewStatus', label: '审核状态', visible: true, minWidth: 80, align:'center'},
        { prop: 'operation',label: '操作', visible: true, minWidth: 160, isInput: false,align:'center' },
      ]

      columns.forEach((item) => {
        if(item.prop=='roomName'){
          item.render =  (row, index, column)=>{
            return <a  onClick={this.handleShowDetail.bind(this, row)}>{row[column.prop]}</a>;
          }
        }else if(item.prop=='roomTypeId' && 1==0){
          item.render =  (row, index, column)=>{
            return <span>{this.selOptionMaps.roomType[row[column.prop]]}</span>;
          }
        }else if(item.prop=='areaName'){
          item.render =  (row, index, column)=>{
            return <span>{`${row.province} ${row.city} ${row.region}`}</span>;
          }
        }else if(item.prop=='reviewStatus' || item.prop=='businessStatus'){
          item.render =  (row, index, column)=>{
            let types = {}
            if(column.prop=='businessStatus'){
              types = {1:'待上架',2:'已上架',3:'已下架'}  
            }else{
              types = {1:'审核中',2:'已通过',3:'未通过',4:'已注销'}
            }
            return <span>{types[row[column.prop]]}</span>;
          }
        }else if(item.prop=='operation'){
          item.render =  (row, index, column)=>{
            let checkFlag = row.reviewStatus==1 ? true:false
            let cancelFlag = row.reviewStatus!=4 ? true:false
            
           
              return (
              <div class="operation">
                <el-button
                    class="border-btn warn"
                    size="small"
                    v-permission="cancel"
                    disabled={!cancelFlag}
                    onClick={this.handleUnregist.bind(this, row)}
                >注销</el-button>
                <el-button
                    class="border-btn primary"
                    size="small"
                    v-permission="audit"
                    disabled={!checkFlag}
                    onClick={this.handleCheck.bind(this, row)}
                >审核</el-button>
              </div>
            ) 
          }
        }else{
          item.render =  (row, index, column)=>{
            if( row[column.prop]===undefined || row[column.prop]===null){
              return <span>--</span>;
            }else{
              return <span>{ row[column.prop] }</span>;
            }
          }
        }
      })

      this.tableColumn = columns
    },
    //获取详情信息
    async getDetailInfo(id,detailType){
      let url = 'SAAS.ROOM_DETAIL'
      let params = {id:id}
      let detailInfo  = await this.fetchData({
        url,
        method: 'get',
        params,
        flag:true
      })
      return detailInfo
    },
    handleShowDetail(row) {
      this.getDetailInfo(row.id,'show').then((res)=>{
        this.detailData = {...res.data} || {}
        this.$nextTick(()=>{
          this.detailType = 'show'
          this.modalTitle = '详情'
          this.detailModal = true
        })
      }).catch((err)=>{
        console.log(err,'err======')
      })
    },
    handleEdit(detailType){
      this.$nextTick(()=>{
        if((detailType=='edit'||detailType=='bind' || detailType=='check' || detailType=='copy') && this.options.selection.length){
          this.getDetailInfo(this.options.selection[0].id,'show').then((res)=>{
            this.detailData = res.data || []
            this.detailData.dwbgdzSfbm = this.detailData.provinceCode //this.detailData.areaCode.substr(0,2)+'0000000000'
            this.detailData.dwbgdzSbm = this.detailData.cityCode ///this.detailData.areaCode.substr(0,4)+'00000000'
            this.detailData.dwbgdzQbm = this.detailData.regionCode //this.detailData.areaCode.substr(0,6)+'000000'
            this.detailData.streetOffice = this.detailData.streetOfficeCode//this.detailData.areaCode.substr(0,10)+'00'
            this.detailData.neighborCmm = this.detailData.neighborCmmCode//this.detailData.areaCode
            this.$nextTick(()=>{
              this.detailType = detailType
              this.modalTitle = detailType=='bind'?'绑定门锁':(detailType=='edit'?'变更':'新增')
              if(detailType=='check'){
                this.modalTitle = '审核'
              }
              this.detailModal = true
            })
          }).catch((err)=>{
            console.log(err,'err======')
          })

          //440305005005
        }else{
          this.detailData = {}
          this.detailType = detailType
          this.modalTitle = '新增'
          this.detailModal = true
        }
      })
    },
    //上架
    handlePutOn(row,status){
      let tipStr = '确定要上架当前房源？'
      this.$confirm(tipStr, { type: 'warning' }).then(() => {
        let id = this.options.selection[0].id
        let params = { id: id,businessStatus:status}
        this.fetchData({ url: 'SAAS.ROOM_EDIT', method: 'post', params: params, timeout: 0, isLoading: false, flag: true ,headers:{'Content-Type':'application/json'}}).then((res) => {
          if (res.code == 200) {
            this.$message.success('操作成功！')
            this.getDataList()
          } else {
            this.$message.error(res.msg || '操作失败！')
          }
        }).catch((err) => {
          if(typeof err ==='string'){
            this.$message.error(err || '操作失败！')
          }
        })
      }).catch(() => false)
    },
    //审核
    handleCheck(row){
      this.getDetailInfo(row.id,'show').then((res)=>{
        this.detailData = {...res.data} || {}
        this.$nextTick(()=>{
          this.detailType = 'check'
          this.modalTitle = '审核'
          this.detailModal = true
        })
      }).catch((err)=>{
        console.log(err,'err======')
      })
    },
    
    handleUnBind() {
      let tipStr = '该操作是不可恢复的，是否解绑？'
      this.$confirm(tipStr, { type: 'warning' }).then(() => {
        let id = this.options.selection[0].id
        let params = {params: JSON.stringify({ id: id}) }
        this.fetchData({ url: 'SAAS.ROOM_UNBIND', method: 'post', params: params, timeout: 0, isLoading: false, flag: true }).then((res) => {
          if (res.status == 1) {
            this.$message.success(res.msg || '操作成功！')
            this.getDataList()
          } else {
            this.$message.error(res.msg || '操作失败！')
          }
        }).catch((err) => {
          if(typeof err ==='string'){
            this.$message.error(err || '操作失败！')
          }

        })
      }).catch(() => false)

    },
    // 处理更多按钮点击事件
    handleMoreBtnCommand(type) {
      switch(type) {
        case 'bind':
          this.handleEdit('bind')
          break
        case 'unBind':
          this.handleUnBind()
          break
        case 'planHouses':
          this.showDistributeModal('distribute')
          break
        case 'callBackHouses':
          this.showDistributeModal('recovery')
          break
        case 'cancel':
          this.handleUnregist()
          break
      }
    },
    handleUnregist(row){
      if(row.msbm || row.msbmBell){
        this.$message.error('房源有绑定设备，解绑后才能注销！')
        return
      }
      let tipStr = '确定注销当前该房源信息？'
      this.$confirm(tipStr, { type: 'warning' }).then(() => {
        let id = this.options.selection[0].id
        let params = { id: id,reviewStatus:4}
        this.fetchData({ url: 'SAAS.ROOM_EDIT', method: 'post', params: params, timeout: 0, isLoading: false, flag: true,headers:{'Content-Type':'application/json'} }).then((res) => {
          if (res.code == 200) {
            this.$message.success('操作成功！')
            this.getDataList()
          } else {
            this.$message.error(res.msg || '操作失败！')
          }
        }).catch((err) => {
          if(typeof err ==='string'){
            this.$message.error(err || '操作失败！')
          }
        })
      }).catch(() => false)
    },
    submitSuccess(){
      this.detailModal=false
      this.distributeModal = false
      this.detailType = ''
      this.searchType = 'formSearch'
      this.getDataList(false)
    },
    closeModel(){
      this.detailModal=false
      this.distributeModal = false
    },
    //点击搜索查询
    formSearch(){
      this.searchType = 'formSearch'
      this.handleSearch()
    },
    // 处理节点点击事件
    handleNodeClick(data, node, treeObj) {
      if (data.type === 'all') {
        this.filters.search.classifyKey = ''
        this.filters.search.classifyValue = ''
      }else if(data.type =='classType'){
        this.filters.search.classifyKey = data.pValue
        this.filters.search.classifyValue = ''
      }else{
        this.filters.search.classifyKey = data.pValue
        this.filters.search.classifyValue = data.value=='未分类'?0:data.value
      }
      this.searchType = 'treeSearch'

      this.handleSearch()
    },
    renderContent(h, { node, data, store }) {
      let  labelStr = node.label
      let classStr = 'node_type_'+data.type
      return (
        <el-tooltip class="item"  effect="dark" content={labelStr} placement="right">
        <span class={classStr}>{node.label}</span>
        </el-tooltip>
      );
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    // 显示房源分配弹框
    showDistributeModal(type) {
      this.distributeType = type
      this.distributeModal = true
    },
    // 获取用户是否拥有审核流程
    getHasCheckFunc(province, city, region) {
      let url = 'SAAS.AUDIT_CONFIG_QUERY_ONE'

      let params = {
        params: JSON.stringify({ province, city, region }),
        start: 0,
        size: 1,
        toExcel: false,
      }

      this.noCheckFunc = false
      this.fetchData({ url, method: 'get', params })
        .then((res) => {
          if (res && res.data) {
            let temp = res.data || {}
            if (temp.id) {
              this.noCheckFunc = temp.houseStatus == 2
            }
          }
        })
    },
    // 处理删除
    handleDelete() {
      let ids = this.options.selection.map(item => Number(item.id))
      this.$confirm(`确定删除当前选中的（${this.options.selection.length}条记录）信息吗？`, '温馨提示', { type: 'warning' }).then(res => {
        if (res === 'confirm') {
          this.deleteRooms(ids)
        }
      })
    },
    // 删除房源
    deleteRooms(ids) {
      let url = 'ROOM.POST_DELETE_BY_IDS'
      this.fetchData({ url, method: 'post', params: ids, flag: true, headers: { 'Content-Type': 'application/json' } })
        .then((res) => {
          if (res.code === 200) {
            this.$message.success('删除成功！')
            this.getDataList()
            return
          }
          this.$message.error(res.msg || '删除失败！')
        })
        .catch(err => {
          this.$message.error(err || '删除失败！')
        })
    }
  }
}
</script>

<style lang="less" scoped>
.room{
  background-color: white;
  border-radius: 8px;
}
</style>